import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./contexts/user-context";
import { TwilioProvider } from "./contexts/TwilioContext";
import AppRoutes from "./routes/app-routes";
import TwilioCallHandler from "./components/twilio-call-handler";
import TwilioStatusIndicator from "./components/twilio-status-indicator";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const userRole = localStorage.getItem('userRole');
  const isOperario = userRole === "ROLE_OPERARIO";

  return (
    <UserProvider>
      <TwilioProvider>
        <BrowserRouter>
          <AppRoutes />
          <TwilioCallHandler />
          {!isOperario && <TwilioStatusIndicator />}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </BrowserRouter>
      </TwilioProvider>
    </UserProvider>
  );
}

export default App;
